/**
 * Where to send a click on a username/avatar inside an activity row.
 *
 * Activities authored by a FrenFlow user (posts, in-app trades, copytrades)
 * resolve to /profile/<username> — that's a real FrenFlow profile with
 * social, posts, etc. Whale/tracker events come from scraped wallets that
 * don't have a FrenFlow account, so they keep /traders/@<address>.
 */
export function activityProfileHref(event: {
  source_table?: string;
  event_type?: string;
  source_username?: string;
  source_wallet?: string;
  metadata?: { wallet_address?: string } & Record<string, any>;
}): string {
  const isPost = event.source_table === "post";
  const isFrenflowAuthor =
    isPost ||
    event.event_type === "copy_trade" ||
    event.event_type === "user_trade" ||
    event.event_type === "user_post" ||
    event.event_type === "user_post_trade" ||
    event.event_type === "user_post_opinion" ||
    event.event_type === "frenflow_trade";

  const traderWallet = event.source_wallet || event.metadata?.wallet_address;

  if (isFrenflowAuthor && event.source_username) {
    return `/profile/${event.source_username}`;
  }
  if (traderWallet) {
    return `/traders/@${traderWallet}`;
  }
  return `/profile/${event.source_username || "anonymous"}`;
}
